import React, { Suspense } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { getBlogPostComponent } from './blog-post-components';

export default function BlogPostRoute() {
  const { postId } = useParams();
  const BlogPostComponent = getBlogPostComponent(postId);
  if (!BlogPostComponent) return <Navigate to="/blog" replace />;

  return (
    <Suspense fallback={<p role="status">Loading article…</p>}>
      <BlogPostComponent />
    </Suspense>
  );
}
